export default __webpack_public_path__ + "static/media/snacks.b1fada90.jpg";